import { useSdkWebsocketConnexion, WebSocketStatus } from "@kalyzee/kast-web-sdk";
import { useRef } from "react";
import { Outlet } from "react-router-dom";
import ConnexionView from "../../../../components/utils/ConnexionView";
import { sdkClient } from "../../../../helpers/sdk";
import styles from "./private.module.css";
import { SessionMode } from "../../../../contexts/appStore/hooks";
import { useAppStoreSelector } from "../../../../contexts/appStore/selectors";

const PrivatePage = () => {
  const mode = useAppStoreSelector(state => state.mode);
  const screen = useAppStoreSelector(state => state.screen);
  const { socketStatus, retry } = useSdkWebsocketConnexion(sdkClient, mode === SessionMode.MASTER);
  const elementRef = useRef<HTMLDivElement>(null);

  const status = socketStatus === WebSocketStatus.Loading ? "connecting" : socketStatus === WebSocketStatus.Online ? "connected" : "disconnected";
  
  return (
    <div className={styles.mainContainer} ref={elementRef}>
      {screen !== undefined ? (
        <div style={{ position: "absolute", top: "10px", right: "10px", color: "black", fontSize: "26px", fontWeight: "bold" }}>{`${screen}`}</div>
      ) : null}
      { mode === SessionMode.MASTER && <ConnexionView
        status={status}
        retry={() => {
          retry();
        }}
      />}
      { mode !== SessionMode.MASTER || status === "connected" ? (
        <div className={styles.main}>
          <Outlet />
        </div>
      ) : null}
    </div>
  );
};

export default PrivatePage;
